import { render, staticRenderFns } from "./PanelUTable.vue?vue&type=template&id=70d5aba8&scoped=true&"
import script from "./PanelUTable.vue?vue&type=script&lang=js&"
export * from "./PanelUTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelUTable.vue?vue&type=style&index=0&id=70d5aba8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5aba8",
  null
  
)

export default component.exports